import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "simple-datatables/dist/style.css";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid"; // veya outline
import LoadingSpinner from "../../layout/spinner";
import Button from "../../layout/button";
import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import { Auth } from "aws-amplify";
import { setCurrentSurvey, updateTabStates } from "../../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { updateSurveyFromAPI } from "../../../services/surveyService";

export default function CollectImportFromSurvey() {
  const dispatch = useDispatch();

  const themeMode = useSelector((state) => state.themeMode);
  const surveys = useSelector((state) => state.surveys);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  // const surveys = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.surveys;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;

  const filterMenuRef = useRef(null);
  let [token, setToken] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [surveysSearchTerm, setSurveysSearchTerm] = useState("");
  const [selectedLabel, setSelectedLabel] = useState(""); // Store selected label
  const [clearFilter, setClearFilter] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isImportVisible, setIsImportVisible] = useState(false);
  const itemsPerPage = 1000;
  const [importAllowMenuOpen, setImportAllowMenuOpen] = useState(false);
  const [importInfoMenuShow, setImportInfoMenuShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [selectedFunction, setSelectedFunction] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [sortedData, setSortedData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [filteredSearchData, setFilteredSearchData] = useState([]);
  const [selectedSurveyName, setSelectedSurveyName] = useState("Surveys");
  const [pageIsLoading,setPageIsLoading]=useState(false)
  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }

  useEffect(() => {
    if (token.length > 0) {
      if (selectedFunction === "updateSurveyUserList") {
        updateSurveyUserList();
      }
      setSelectedFunction("");
    }
  }, [token]);

  // Toggle the visibility of the popup
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const toggleSearchBar = () => {
    setIsSearchBarOpen(!isSearchBarOpen);
  };

  // Satır seçimini işlemek için fonksiyon
  const handleRowSelect = (user) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(user)) {
        return prevSelected.filter((row) => row !== user);
      } else {
        return [...prevSelected, user];
      }
    });
  };

  const sortOptions = [
    { name: "Name", href: "#", current: false },
    { name: "Email", href: "#", current: false },
    { name: "Organization", href: "#", current: true },
  ];
  const [data, setData] = useState([]);

  const [switchStates, setSwitchStates] = useState(
    sortOptions.reduce((acc, option) => {
      acc[option.name] = true; // Tüm switch'ler başlangıçta kapalı
      return acc;
    }, {})
  );
  const handleSwitchToggle = (name) => {
    setSwitchStates((prev) => ({
      ...prev,
      [name]: !prev[name], // Geçerli switch'in durumunu tersine çevir
    }));
  };
  const handleMenuItemClick = (label) => {
    setSelectedLabel(label); // Set selected label for filtering
    setShowSearchBar(true); // Show the search bar
  };
  useEffect(() => {
    const filtered = data.filter((row) =>
      row.first_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  }, [data, searchTerm]);
  // Paginate data
  const startIndex = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    const filteredSearch = filteredData.filter((row) => {
      if (!selectedLabel || !filterSearchTerm) return true; // Eğer filtre seçilmemişse tüm veriyi göster
      if (selectedLabel.toLowerCase() === "name") {
        const fullName = (row.first_name + " " + row.last_name).toLowerCase();
        return fullName.includes(filterSearchTerm.toLowerCase());
      } else if (selectedLabel.toLowerCase() === "organization") {
        const organization = row.organization_name.toLowerCase();
        return organization.includes(filterSearchTerm.toLowerCase());
      } else {
        return row[selectedLabel.toLowerCase()]
          ?.toLowerCase()
          .includes(filterSearchTerm.toLowerCase()); // Seçilen label ve arama terimine göre filtreleme
      }
    });
    setFilteredSearchData(filteredSearch);
  }, [filteredData, selectedLabel, filterSearchTerm]);
  useEffect(() => {
    if (sortConfig.key) {
      const sorted = [...filteredSearchData].sort((a, b) => {
        // Sayılar ve metinler için karşılaştırmayı türüne göre yap
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];
        if (sortConfig.key === "name") {
          valA = a.first_name + " " + a.last_name;
          valB = b.first_name + " " + b.last_name;
        }
        if (sortConfig.key === "organization") {
          valA = a.organization_name;
          valB = b.organization_name;
        }
        // Verinin türüne göre karşılaştırma yap
        if (typeof valA === "string" && typeof valB === "string") {
          // String karşılaştırması (case-insensitive)
          const aLower = valA.toLowerCase();
          const bLower = valB.toLowerCase();

          if (aLower < bLower) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aLower > bLower) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        } else if (typeof valA === "number" && typeof valB === "number") {
          // Sayısal karşılaştırma
          if (valA < valB) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (valA > valB) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        }
        return 0;
      });
      setSortedData(sorted);
    } else {
      setSortedData(filteredSearchData);
    }
  }, [filteredSearchData, sortConfig]);

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSurveyUsers = (survey_id) => {
    setData(surveys.find((survey) => survey.ID === survey_id).survey_users);
    setIsImportVisible(false);
  };

  async function updateSurveyUserList() {
    setImportAllowMenuOpen(false);
    setPageIsLoading(true)
    const new_users = [
      ...currentSurvey.survey_users,
      ...selectedRows.filter(
        (user) =>
          !currentSurvey.survey_users
            .map((user) => user.email)
            .includes(user.email)
      ),
    ];
    const obj = {
      survey_users: new_users,
    };
    await updateSurveyFromAPI(token, obj, currentSurvey.ID)
      .then((result) => {
        let _newCurrentSurvey = { ...currentSurvey };
        _newCurrentSurvey.survey_users = new_users;
        // dispatch(setCurrentSurvey(_newCurrentSurvey));
        dispatch(
          updateTabStates(
            topMenuTabs.activeTab,
            "currentSurvey",
            _newCurrentSurvey
          )
        );
        setSuccess(true);
        setPageIsLoading(false)
        setError(false);
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          setSelectedFunction("updateSurveyUserList");
          checkAuth();
        } else {
          setSuccess(false);
          setError(true);
          setPageIsLoading(false)
        }
      });
 
    setImportInfoMenuShow(true);
  }
  const handleClickOutside = (event) => {
    if (
      filterMenuRef.current &&
      !filterMenuRef.current.contains(event.target)
    ) {
      // Hide the search bar but keep the sortOptions visible
      setShowSearchBar(false);
      setFilterSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setIsImportVisible(selectedRows.length > 0 ? true : false);
  }, [selectedRows]);
  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);

  // 2. useEffect ile component mount olduktan sonra parent div'in genişliğini alıyoruz.
  useEffect(() => {
    if (parentRef.current) {
      setParentWidth(parentRef.current.offsetWidth); // parent genişliğini alıyoruz
    }

    // Resize olduğunda genişliği güncellemek için event listener ekliyoruz.
    const handleResize = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup: component unmount olduğunda event listener'ı temizliyoruz.
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setImportInfoMenuShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [importInfoMenuShow, setImportInfoMenuShow]);
  return (
    <div
      ref={parentRef}
      className={`flex  flex-col h-full w-full justify-between  overflow-y-hidden pb-[4.9rem] ${
        themeMode === "dark" ? "bg-[#1a1a28]  border-gray-200" : "bg-[#fbfbfc]"
      }`}
    >
      <div className="flex-grow">
        <div className="flex items-center justify-between flex-shrink-0 min-w-0 h-[50px] px-12 py-0">
          <div className="flex mr-2 gap-[0.25rem]">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <MenuButton
                  className={`flex items-center self-stretch p-0  h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                    themeMode === "dark"
                      ? "bg-white-02"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                  } `}
                >
                  <div
                    className={`hulyButton font-medium-14 h-[1.5rem] w-[1.5rem] lg:w-[2rem] lg:h-[2rem] min-w-8 border rounded-[0.375rem] cursor-pointer flex justify-center  items-center ${
                      themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                        : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
                    }`}
                    data-id="btn-viewSetting"
                  >
                    <div
                      className={`icon no-gap  inline-flex justify-center  items-center  ${
                        themeMode === "dark" ? "text-[#ffffff]" : "text-[#000]"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4 lg:size-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
                        />
                      </svg>
                    </div>
                  </div>
                </MenuButton>
              </div>

              <MenuItems
                transition
                className={`absolute left-1 z-[99999999] mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                  themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                }`}
              >
                <div className="py-1">
                  {sortOptions.map((option, index) => (
                    <div key={option.name} className="mb-4">
                      <div
                        className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md ${
                          themeMode === "dark"
                            ? "hover:bg-[#333240] text-white"
                            : "hover:bg-[#EBEBEB] text-black"
                        }`}
                      >
                        <label
                          htmlFor={`switch-${index}`}
                          className={`ms-3 text-sm font-medium ${
                            themeMode === "dark"
                              ? "text-[#f7f8f8]"
                              : "text-[#131416]"
                          }`}
                        >
                          {option.name}
                        </label>

                        <div className="relative inline-block w-11 h-5">
                          <input
                            id={`switch-${index}`}
                            type="checkbox"
                            className="peer appearance-none w-11 h-5 bg-[rgba(120,120,128,0.32)] rounded-full checked:bg-[#205dc2] cursor-pointer transition-colors duration-300"
                            checked={switchStates[option.name]} // Durumdan gelen değer
                            onChange={() => handleSwitchToggle(option.name)} // Tıklamayı işle
                          />
                          <label
                            htmlFor={`switch-${index}`}
                            className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow-sm transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
                          ></label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </MenuItems>
            </Menu>
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <MenuButton
                  className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                    themeMode === "dark"
                      ? "bg-white-02"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                  } `}
                >
                  <div
                    className={`hulyButton font-medium-14 h-[1.5rem] lg:h-[2rem] w-auto px-2 border rounded-[0.375rem] cursor-pointer flex justify-center  items-center gap-2 ${
                      themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                        : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                    }`}
                    data-id="btn-viewSetting"
                  >
                    <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                    {selectedSurveyName}
                    </span>
                    <div
                      className={`icon no-gap  inline-flex justify-center  items-center  ${
                        themeMode === "dark" ? "text-[#ffffff]" : "text-[#000]"
                      }`}
                    >
                      <ChevronDownIcon className="size-4 lg:size-5" />
                    </div>
                  </div>
                </MenuButton>
              </div>

              <MenuItems
                transition
                className={`absolute left-1 z-[99999999]  w-64 h-[250px]  origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                  themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                }`}
              >
                <div className="px-1 py-2">
                  <div className="px-4">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={surveysSearchTerm}
                    onChange={(e) => setSurveysSearchTerm(e.target.value)}
                    className={`w-full px-2 py-1 mb-2 rounded-md ${
                      themeMode === "dark"
                        ? " bg-[#2a2939]  shadow-theme-popup-shadow  placeholder:text-white text-white"
                        : "bg-[#FFFFFF] shadow-black-2-shadow placeholder:text-black text-black"
                    }`}
                  />
                  </div>
                  <div className="flex-grow min-h-0 h-max overflow-x-hidden">
                    <div className="flex flex-col  overflow-y-auto h-[200px]">
                      {surveys
                        .filter(
                          (option) =>
                            (
                              !surveysSearchTerm.trim() ||
                              option.survey_name
                                .toLowerCase()
                                .includes(surveysSearchTerm.toLowerCase())
                            )
                            && option.ID !== currentSurvey.ID
                        )
                        .map((option, index) => (
                          <div
                            key={option.ID}
                            className="cursor-pointer"
                            onClick={() => {setSelectedSurveyName(option.survey_name);;getSurveyUsers(option.ID)}}
                          >
                            <div
                              className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer ${
                                themeMode === "dark"
                                  ? "hover:bg-[#333240] text-white"
                                  : "hover:bg-[#EBEBEB] text-black"
                              }`}
                            >
                              <label
                                className={`ms-3 text-sm font-medium cursor-pointer ${
                                  themeMode === "dark"
                                    ? "text-[#f7f8f8]"
                                    : "text-[#131416]"
                                }`}
                              >
                                {option.survey_name}
                              </label>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </MenuItems>
            </Menu>
          </div>
          <div className="flex flex-end gap-2 ">
            <label
              className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem] lg:h-[2rem]  min-w-8  rounded-md shadow-inner cursor-text transition-all max-w-8 focus-within:max-w-[15rem] focus-within:pr-1 focus-within:p-0.25 active:max-w-[15rem] active:pr-1 active:p-0.25 ${
                themeMode === "dark"
                  ? "bg-white-02"
                  : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
              }`}
            >
              <div
                className={`flex items-center justify-center flex-shrink-0 p-0 bg-transparent border-none outline-none cursor-pointer rounded-md h-8 w-8  mr-1 focus-within:cursor-text ${
                  themeMode === "dark" ? "text-white placeholder:text-white" : "text-[#0f121a] placeholder:text-[#0f121a]"
                }`}
              >
                <svg
                  className="w-[1rem] h-[1rem]"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    file-rule="evenodd"
                    clipRule="evenodd"
                    d="M10.7241 10.0168L14.3535 13.6465C14.5488 13.8417 14.5488 14.1583 14.3535 14.3536C14.1602 14.5469 13.8478 14.5488 13.6522 14.3592L10.017 10.7238C8.9277 11.6312 7.5305 12.0836 6.11608 11.9871C4.70165 11.8905 3.37891 11.2524 2.423 10.2054C1.4671 9.15843 0.951637 7.78323 0.983845 6.36588C1.01605 4.94853 1.59345 3.59816 2.59593 2.59568C3.5984 1.59321 4.94877 1.01581 6.36612 0.983601C7.78347 0.951393 9.15867 1.46686 10.2057 2.42276C11.2526 3.37866 11.8908 4.70141 11.9873 6.11583C12.0839 7.53026 11.6314 8.92745 10.7241 10.0168ZM2.75851 3.99981C2.26404 4.73983 2.00012 5.60986 2.00012 6.49987C2.00144 7.69294 2.47597 8.83677 3.3196 9.68039C4.16323 10.524 5.30705 10.9986 6.50012 10.9999C7.39013 10.9999 8.26016 10.736 9.00018 10.2415C9.7402 9.74702 10.317 9.04422 10.6576 8.22195C10.9982 7.39968 11.0873 6.49488 10.9137 5.62197C10.74 4.74905 10.3114 3.94723 9.6821 3.31789C9.05276 2.68856 8.25094 2.25997 7.37802 2.08634C6.50511 1.91271 5.60031 2.00182 4.77804 2.34242C3.95578 2.68301 3.25297 3.25979 2.75851 3.99981Z"
                  ></path>
                </svg>
              </div>
              <input
                type="text"
                className={`mr-3 p-0 w-full h-full ${
                  themeMode === "dark" ? "text-white placeholder:text-white" : "text-[#0f121a] placeholder:text-[#0f121a]"
                } caret-[#2a59d6] bg-transparent border-none outline-none appearance-none`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search"
                autoComplete="off"
                spellCheck="false"
              />
            </label>
            <div className="flex items-center hidden">
              <Menu
                as="div"
                className="relative inline-block text-left"
                ref={filterMenuRef}
              >
                <div>
                  <MenuButton
                    className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                      themeMode === "dark"
                        ? "bg-white-02"
                        : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                    } `}
                  >
                    {filterSearchTerm !== "" ? (
                      <div
                        onClick={() => {
                          setFilterSearchTerm("");
                          setShowSearchBar(false);
                        }} // Reset search term to empty string
                        className={`px-3 py-1 text-sm border  flex justify-jenter items-center rounded-[0.375rem] border-solid gap-1 ${
                          themeMode === "dark"
                            ? " bg-white-02 border-white-09 hover:bg-white-08 hover:text-[#fff] text-white-8"
                            : " bg-black-02 border-black-09 hover:bg-black-08 hover:text-[#000] text-black-8"
                        }`}
                      >
                        <div
                          className={`btn-icon pointer-events-none ${
                            themeMode === "dark"
                              ? "text-white-8"
                              : "text-black-8"
                          }`}
                        >
                          <svg
                            className="svg-small  w-[.8rem] h-[.8rem]"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                          </svg>
                        </div>
                        <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                          Clear filter
                        </span>
                      </div>
                    ) : (
                      <div
                        className={`flex items-center justify-center gap-3 p-0 px-3 bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${
                          themeMode === "dark"
                            ? "hover:text-[#fff] text-white-8"
                            : "hover:text-[#000] text-black-8"
                        }`}
                        type="button"
                        onClick={() => {
                          setFilterSearchTerm("");
                          setShowSearchBar(false);
                          togglePopup();
                        }}
                      >
                        <div className="pointer-events-none">
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                          </svg>
                        </div>
                        <span className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-500 cursor-not-allowed">
                          Filter
                        </span>
                      </div>
                    )}
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className={`absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                    themeMode === "dark"
                      ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                      : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                  }`}
                >
                  <div className="py-1">
                    {showSearchBar && clearFilter ? (
                      <div className="px-4 py-2">
                        <input
                          type="text"
                          placeholder="Search..."
                          value={filterSearchTerm}
                          onChange={(e) => setFilterSearchTerm(e.target.value)}
                          className={`w-full px-2 py-1 border rounded-md  ${
                            themeMode === "dark"
                              ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow  placeholder:text-white-6 text-white"
                              : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow placeholder:text-black-6 text-black-6"
                          }`}
                        />
                      </div>
                    ) : (
                      sortOptions.map((option) => (
                        <MenuItem key={option.name}>
                          <a
                            href={option.href}
                            className={`${
                              themeMode === "dark"
                                ? "text-[#fff] hover:bg-[#333240]"
                                : "text-[#000] hover:bg-[#EBEBEB]"
                            } block px-4 py-2 text-sm data-[focus]:outline-none`}
                            onClick={(e) => {
                              e.preventDefault(); // Varsayılan bağlantı davranışını durdurur
                              e.stopPropagation(); // Tıklamanın menüyü kapatmasını engeller
                              handleMenuItemClick(option.name);
                            }}
                          >
                            {option.name}
                          </a>
                        </MenuItem>
                      ))
                    )}
                  </div>
                </MenuItems>
              </Menu>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto  overflow-y-auto flex-1  ">
          <table
            className={`min-w-full border border-b border-solid border-[1px] table-fixed ${
              themeMode === "dark"
                ? " bg-[#1C1C29] border-white-06"
                : "bg-[#efeff2] border-black-06"
            }`}
          >
            <thead
              className={`border border-b border-t-0 border-r-0 border-l-0 border-solid border-[1px] w-auto ${
                themeMode === "dark"
                  ? "bg-[#1C1C29] border-white-06"
                  : "bg-[#efeff2] border-black-06"
              }`}
            >
              <tr>
                <th
                  className={`h-12 p-2.5 pl-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    onChange={() => {
                      if (
                        selectedRows.length === data.length &&
                        selectedRows.length !== 0
                      ) {
                        setSelectedRows([]);
                      } else {
                        setSelectedRows(data);
                      }
                    }}
                    checked={
                      selectedRows.length === data.length &&
                      selectedRows.length > 0
                    }
                  />
                </th>
                {switchStates["Name"] && (
                  <th
                    onClick={() => handleSort("name")}
                    className={`h-12 p-2.5 pl-6 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  w-1/5 ${
                      themeMode === "dark"
                        ? "text-white text-opacity-60"
                        : "text-gray-600"
                    }`}
                  >
                    <div className="flex justify-start gap-2">
                      Name{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                        />
                      </svg>
                    </div>
                  </th>
                )}
                {switchStates["Email"] && (
                  <th
                    onClick={() => handleSort("email")}
                    className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light w-1/5 ${
                      themeMode === "dark"
                        ? "text-white text-opacity-60"
                        : "text-gray-600"
                    }`}
                  >
                    <div className="flex justify-start gap-2">
                      Email
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                        />
                      </svg>
                    </div>
                  </th>
                )}
                {switchStates["Organization"] && (
                  <th
                    onClick={() => handleSort("organization")}
                    className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  ${
                      themeMode === "dark"
                        ? "text-white text-opacity-60"
                        : "text-gray-600"
                    }`}
                  >
                    <div className="flex justify-start gap-2">
                      Organization
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                        />
                      </svg>
                    </div>
                  </th>
                )}
              </tr>
            </thead>
            <tbody
              className={`  ${
                themeMode === "dark" ? "bg-[#21212F]" : "bg-[#f4f4f6]"
              }`}
            >
              {sortedData.map((row) => (
                <tr
                  key={row.user_id}
                  className={` h-13 border-b cursor-pointer ${
                    selectedRows.includes(row)
                      ? themeMode === "dark"
                        ? "bg-[#252b3a] text-[#FFF] hover:bg-[#2c3346]" // Dark mode'da seçilen satır rengi
                        : "bg-[#f0f4ff] text-[#000] hover:bg-[#e4ebff]" // Light mode'da seçilen satır rengi
                      : themeMode === "dark"
                      ? "text-[#FFF] hover:bg-[#282834] border-[rgba(255,255,255,0.06)]"
                      : "hover:bg-[#E8E8E9] border-[rgba(0,0,0,0.06)]"
                  }`}
                  onClick={() => handleRowSelect(row)}
                >
                  <td className="p-2.5 pl-12 text-left text-sm">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      defaultChecked={selectedRows.includes(row)}
                      // onChange={() => handleRowSelect(row)}
                    />
                  </td>
                  {switchStates["Name"] && (
                    <td className="p-2.5 pl-6 text-left text-sm ">
                      {row.first_name + " " + row.last_name}
                    </td>
                  )}
                  {switchStates["Email"] && (
                    <td className="p-2.5 pl-6 text-left text-sm ">
                      {row.email}
                    </td>
                  )}
                  {switchStates["Organization"] && (
                    <td className="p-2.5 pl-6 text-left text-sm ">
                      <div className="flex">
                        <BuildingOffice2Icon className="w-5 h-5 mr-2" />
                        {row.organization_name}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Pagination Controls */}
      {/* {isImportVisible && (
    <div className={`flex w-full justify-start gap-2 cursor-pointer ml-21 py-4 mb-8 pl-2  bottom-0 fixed ${themeMode === "dark" ? "bg-[#1F1F2C]" : "bg-[#fbfbfc]"
    }`}>
      <a
        className="flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem] bg-[#205dc2] hover:bg-[#3575DE] text-[#FFFFFF] group inline-flex items-center py-2 pl-2 pr-2 text-sm font-medium min-w-[4.5rem] max-w-[4.9rem]"
        onClick={() => updateSurveyUserList()}
      >
        Import
      </a>
    </div>
  )} */}
      <div
        className={`flex justify-between px-8 pr-8 bottom-0 fixed  py-2  z-10 overflow-x-auto ${
          themeMode === "dark" ? "bg-[#1F1F2C]" : "bg-[#fbfbfc]"
        } h-[2.5rem] `}
        style={{ width: `${parentWidth}px` }}
      >
        <label
          className={`space-x-2 pl-[0.7rem] ${
            themeMode === "dark" ? "text-[#868a94]" : "text-[#54585f]"
          } text-[0.875rem]`}
        >
          <span>Total:</span>
          <span>{Math.ceil(filteredData.length)}</span>
        </label>
        {isImportVisible && (
          <Button 
          text="Import" 
          onClick={() => setImportAllowMenuOpen(true)}
          disabled={false} 
          themeMode={themeMode}
          className="flex justify-center items-center cursor-pointer flex-nowrap flex-shrink-0 rounded-[0.375rem]"
        />
        
        )}
      </div>
      <Dialog
        open={importAllowMenuOpen}
        onClose={setImportAllowMenuOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    Import Selected User
                  </DialogTitle>
                  <div className="mt-1">
                    <p
                      className={`text-sm ${
                        themeMode === "dark" ? "text-white-8" : "text-black-8"
                      }`}
                    >
                      Are you sure you want to import selected users to this
                      survey
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => updateSurveyUserList()}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setImportAllowMenuOpen(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${
                    themeMode === "dark"
                      ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                      : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={importInfoMenuShow}
        onClose={setImportInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.8rem]">
          <div className=" absolute flex min-h-full max-w-full min-w-[15%] items-end justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    {success && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        <span>Survey updated</span>
                      </div>
                    )}
                    {error && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                        <span>Survey couldn't update</span>
                      </div>
                    )}
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setImportInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
        {pageIsLoading && (
              <LoadingSpinner />
            )}
    </div>
  );
}
